import { useEffect } from 'react';
import Decimal from 'decimal.js';
import { Row, TextButton, Tooltip } from 'seagull';
import { addStage, removeStage, setFinalStage, calculateStages, isValueTypeDollars, getDisabledReasonTooltip } from "./BillingStagesSelect.utils";
import { Stage } from "./Stage";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const BillingStagesSelect = _ref => {
  let {
    discount,
    totalRate,
    isAmendment,
    effectiveDate,
    stageClassName,
    disabledReason,
    oneTimeInStagesBilling,
    setOneTimeInStagesBilling
  } = _ref;
  const stages = oneTimeInStagesBilling.stages();
  const valueType = oneTimeInStagesBilling.valueType();
  useEffect(() => {
    if (isValueTypeDollars(valueType)) {
      const newStages = [...stages];
      const lastStageIndex = newStages.length - 1;
      const currentLastStageValue = newStages[lastStageIndex].value;
      setFinalStage(newStages, valueType, totalRate);
      const newLastStageValue = newStages[lastStageIndex].value;
      if (!currentLastStageValue.equals(newLastStageValue)) setOneTimeInStagesBilling(oneTimeInStagesBilling.setStages(newStages));
    }
  }, [totalRate, valueType, stages, oneTimeInStagesBilling, setOneTimeInStagesBilling]);
  const handleAddStage = () => {
    setOneTimeInStagesBilling(oneTimeInStagesBilling.setStages(addStage(stages)));
  };
  const handleRemoveStage = indexToRemove => {
    setOneTimeInStagesBilling(oneTimeInStagesBilling.setStages(removeStage(stages, indexToRemove)));
  };
  const handleChangeValueType = valueType => {
    setOneTimeInStagesBilling(oneTimeInStagesBilling.setValueType(valueType).setStages(calculateStages({
      length: stages.length,
      totalRate,
      valueType
    })));
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [stages.map((stage, index, _ref2) => {
      let {
        length
      } = _ref2;
      return /*#__PURE__*/_jsx(Stage, {
        stage: stage,
        discount: discount,
        stageClassName: stageClassName,
        totalRate: totalRate,
        discountedTotalRate: totalRate.mul(new Decimal(1).minus(discount.div(100))),
        isLast: index === length - 1,
        isFirst: index === 0,
        index: index,
        disabledReason: disabledReason,
        oneTimeInStagesBilling: oneTimeInStagesBilling,
        totalSumExceedsRate: stages.reduce((acc, stage) => acc.plus(stage.value), new Decimal(0)).gt(isValueTypeDollars(valueType) ? totalRate : new Decimal(100)),
        onRemove: () => handleRemoveStage(index),
        onValueTypeChange: handleChangeValueType,
        onChange: stage => {
          const newStages = [...stages];
          newStages[index] = stage;
          setFinalStage(newStages, valueType, totalRate);
          setOneTimeInStagesBilling(oneTimeInStagesBilling.setStages(newStages));
        },
        effectiveDate: effectiveDate,
        isAmendment: isAmendment
      }, index);
    }), /*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsx(Tooltip, {
        title: getDisabledReasonTooltip(disabledReason) || (stages.length >= 6 ? 'The maximum number of allowed stages is 6' : ''),
        children: /*#__PURE__*/_jsx(TextButton, {
          disabled: !!disabledReason || stages.length >= 6,
          onClick: handleAddStage,
          underline: false,
          testId: "add-stage",
          children: "+Add stage"
        })
      })
    })]
  });
};